// Brand colors
export const BRAND_COLOR = "oklch(0.56 0.14 51.07)";

// Holdings
export const INVESTMENT_CATEGORIES = ["Growth", "Dividend", "Value", "Speculative"] as const;
export const HOLDING_TYPES = ["Shares", "ETF", "Bond", "REIT"] as const;

// Risk profiles
export const RISK_PROFILES = [
  { value: "conservative", drawdown: 0.10 },
  { value: "moderate", drawdown: 0.20 },
  { value: "aggressive", drawdown: 0.35 },
  { value: "veryAggressive", drawdown: 0.50 },
] as const;

// Supported currency codes
export const SUPPORTED_CURRENCIES = [
  "USD", "EUR", "GBP", "CHF", "JPY", "CAD", "AUD", "PLN", "RUB", "KZT", "CNY", "INR", "BRL",
] as const;
